const initialState =
{
    data: [],
    saving: false,
};

export default (state = initialState, action) => {
    switch(action.type)
    {
        case 'LIST':
            return {
                ...state,
                data: action.payload
            }
        case 'SAVE':
            return {
                ...state,
                saving: true
            }

        case 'SAVE_SUCCESS':
            return {
                ...state,
                saving: false,
                data: [ action.payload,...state.data]
            }       
            
        case 'UPDATE_SUCCESS':
            let newp = action.payload;
            return {
                ...state,
                saving: false,
                data: state.data.map((d, i) => { return (d.value == newp.value) ? newp : d })
            }
            break;

            case 'DESACTIVAR':
            
            return {
                ...state,
                saving: false,
                data: state.data.map((d, i) => { 
                     var newp ={
                        estado:"Desactivado",
                        value: d.value,
                        venta: d.venta,
                        compra: d.compra,
                        inicio : d.inicio,
                        final : d.final,
                     };
                    return (d.estado == "Activo") ? newp : d 

                })
            }
            break;

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/tiposcambio.js